import styled from "styled-components";

import { color, font, Option } from "@runwayhealth/runway-components-react";
import { Medication } from "@types-runway/condition";

type MedicationCardProps = {
  medication: Medication;
  price: string;
  isSelected: boolean;
  description: string;
  onSelect: () => void;
};

const MedicationOption = styled(Option)`
  margin-bottom: 0;
  label {
    /* Override Option's default label padding to align with the multi-option card layout */
    padding: 8px 16px 8px 20px !important;
  }
  div[variant="radio"] {
    margin-top: 12px;
    margin-bottom: 12px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const MedicationLabel = styled.span`
  font-family: ${font.family};
  font-weight: 700;
  font-size: 1rem;
  color: ${color.brand.secondary.dark};
`;

const MedicationName = styled(MedicationLabel)``;

const MedicationPrice = styled(MedicationLabel)``;

const DescriptionContainer = styled.div<{ $isVisible: boolean }>`
  display: grid;
  grid-template-rows: ${(props) => (props.$isVisible ? "1fr" : "0fr")};
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  transition: grid-template-rows 300ms ease-out, opacity 250ms ease-out;

  > * {
    overflow: hidden;
  }
`;

const DescriptionBox = styled.div`
  padding: 12px 16px;
  border: 2px solid ${color.brand.primary.lighter};
  border-top: none;
  border-radius: 0 0 13px 13px;
  margin-bottom: 8px;
`;

const MedicationDescription = styled.p`
  line-height: 1.5;
  margin: 0;
`;

export const MedicationCard = ({
  medication,
  price,
  isSelected,
  description,
  onSelect,
}: MedicationCardProps) => {
  return (
    <>
      <MedicationOption
        checked={isSelected}
        onClick={onSelect}
        data-testid={`medication-card-${medication.id ?? medication.name}`}
      >
        <ContentWrapper>
          <MedicationName>{medication.name}</MedicationName>
          <MedicationPrice>{price}</MedicationPrice>
        </ContentWrapper>
      </MedicationOption>
      <DescriptionContainer $isVisible={isSelected}>
        <DescriptionBox>
          <MedicationDescription>{description}</MedicationDescription>
        </DescriptionBox>
      </DescriptionContainer>
    </>
  );
};
